import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SectionHeading } from '@/components/sections/SectionHeading';

export const TrustSection = () => {
  const { t } = useTranslation();
  const pillars = t('trust.pillars', { returnObjects: true });
  return (
    <section className="px-6 py-24 sm:py-32 lg:px-8">
      <SectionHeading eyebrow={t('trust.eyebrow')} title={t('trust.title')} subtitle={t('trust.subtitle')} />
      <div className="mx-auto mt-16 grid max-w-6xl gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {pillars.map((p, i) => {
          const Icon = Icons[p.icon] || Icons.ShieldCheck;
          return (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#001826]/70 p-7 transition-colors hover:border-brand/30"
            >
              <div className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-brand/10 opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
              <span className="relative flex h-12 w-12 items-center justify-center rounded-2xl bg-[#001826] text-brand ring-1 ring-brand/20 transition-transform duration-300 group-hover:scale-110">
                <Icon className="h-6 w-6" />
              </span>
              <h3 className="relative mt-5 font-display text-base font-semibold text-white">{p.title}</h3>
              <p className="relative mt-2 text-sm leading-relaxed text-white/55">{p.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
